'use es6';

import keyMirror from 'react-utils/keyMirror';
export default keyMirror({
  ADD_NOTIFICATION: null,
  REMOVE_NOTIFICATION: null,
  REMOVE_ALL_NOTIFICATIONS: null
});